import {GET, POST,PUT} from '../http';

export const GetCustomers = spec=>{
    return GET("CRM/Customers/GetCustomers",spec)
}

export const SearchGuestByString = spec=>{
    return GET("CRM/Guest/SearchByString",spec)
}

export const SearchGuest = spec=>{
    return GET("CRM/Guest/Search",spec)
}

export const UpdateCustomers = spec=>{
    return POST("CRM/Customers/UpdateCustomers",spec)
}
export const DeleteCustomerChannelMappings = spec=>{
    return PUT("CRM/Customers/DeleteCustomerChannelMappings",spec)
}

export const CreateGuest = spec=>{
    return POST("CRM/GuestDataService/CreateGuest",spec)
}
export const UpdateGuest = spec=>{
    return POST("CRM/GuestDataService/UpdateGuest",spec)
}

export const GetGuests = spec=>{
    return GET("CRM/Guest/GetGuests",spec)
}